import { Component, Input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

interface SubItem {
  activeSectionId: number;
  translocoKey: string;
  link: string;
}
interface Section {
  titleKey: string;
  items?: SubItem[];
  link?: string;
  activeSectionId?: number;
}

export enum AdminSectionId {
  MARKET_DATA = 0,
  SALES_AGENTS = 1,
  SALES_AGENTS_DATA = 2,
  FILE_DATA = 3,
  JSON_GENERATOR = 4,
  FILE_EXTRACTION = 5,
  ELECTRICITY_INVOICE_CHECK_REVIEW = 6,
  GAS_INVOICE_CHECK_REVIEW = 7,
  COMPANY_DASHBOARD = 8,
  PRODUCTS_SERVICES = 9,
  OPPORTUNITIES = 10,
  SIGNALS = 11,
  INDICATORS = 12,
  VARIABLES = 13,
  FILE_MANAGEMENT = 14,
  PROMOTION_CODES = 15,
}

@Component({
  selector: 'app-admin-navigation',
  standalone: true,
  imports: [TranslocoPipe, CommonModule, RouterLink],
  templateUrl: './admin-navigation.component.html',
  styleUrl: './admin-navigation.component.css'
})
export class AdminNavigationComponent {
  @Input() isActiveNumber: number = 0;

  sections: Section[] = [
    {
      titleKey: 'admin.sections.sales',
      items: [
        { activeSectionId: AdminSectionId.SALES_AGENTS, translocoKey: 'admin.sales_agents', link: '/admin/sales-agents' },
        { activeSectionId: AdminSectionId.SALES_AGENTS_DATA, translocoKey: 'admin.sales_agents_data', link: '/admin/sales-agents-data' },
        { activeSectionId: AdminSectionId.PROMOTION_CODES, translocoKey: 'admin.promotion_codes', link: '/admin/promotion-codes' },
      ],
    },
    {
      titleKey: 'admin.sections.invoice_review',
      items: [
        { activeSectionId: AdminSectionId.ELECTRICITY_INVOICE_CHECK_REVIEW, translocoKey: 'admin.electricity_invoice_check_review', link: '/admin/electricity-invoice-check-review' },
        { activeSectionId: AdminSectionId.GAS_INVOICE_CHECK_REVIEW, translocoKey: 'admin.gas_invoice_check_review', link: '/admin/gas-invoice-check-review' },
      ],
    },
    {
      titleKey: 'admin.sections.file_tools',
      items: [
        { activeSectionId: AdminSectionId.FILE_DATA, translocoKey: 'admin.file_data', link: '/admin/file-data' },
        { activeSectionId: AdminSectionId.FILE_EXTRACTION, translocoKey: 'admin.file_extraction', link: '/admin/file-extraction' },
        { activeSectionId: AdminSectionId.JSON_GENERATOR, translocoKey: 'admin.json_generator', link: '/admin/json-generator' },
      ],
    },
    {
      titleKey: 'admin.sections.data_management',
      link: '/admin/file-management',
      activeSectionId: AdminSectionId.FILE_MANAGEMENT,
    },
    {
      titleKey: 'admin.sections.upsell_engine',
      items: [
        { activeSectionId: AdminSectionId.COMPANY_DASHBOARD, translocoKey: 'admin.company_dashboard', link: '/admin/company-dashboard' },
        { activeSectionId: AdminSectionId.PRODUCTS_SERVICES, translocoKey: 'admin.products_services', link: '/admin/products-services' },
        { activeSectionId: AdminSectionId.OPPORTUNITIES, translocoKey: 'admin.opportunities', link: '/admin/opportunities' },
        { activeSectionId: AdminSectionId.SIGNALS, translocoKey: 'admin.signals', link: '/admin/signals' },
        { activeSectionId: AdminSectionId.INDICATORS, translocoKey: 'admin.indicators', link: '/admin/indicators' },
        { activeSectionId: AdminSectionId.VARIABLES, translocoKey: 'admin.variables', link: '/admin/variables' },
      ],
    },
  ];

  // Active top section
  activeSectionIndex = 0;

  ngOnChanges(): void {
    // Find active top section index based on active page number
    const id = this.sections.findIndex(sec =>
      (sec.items && sec.items.some(i => i.activeSectionId === this.isActiveNumber)) ||
      sec.activeSectionId === this.isActiveNumber
    );
    this.activeSectionIndex = id >= 0 ? id : 0;
  }

  onHoverSection(index: number) {
    // Change top section on hover
    this.activeSectionIndex = index;
  }

  isItemActive(id: number) {
    return this.isActiveNumber === id;
  }
}
